module.exports = __webpack_public_path__ + "static/img/home-20210615.e72b5257.jpg";